import { render, staticRenderFns } from "./AllOrders.vue?vue&type=template&id=55d1334e&scoped=true"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"
import style0 from "./AllOrders.vue?vue&type=style&index=0&id=55d1334e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d1334e",
  null
  
)

export default component.exports